(() => {
  // Short banner under Add to cart that points to the kit section. Only appears once a kit has loaded for this tank.
  const Kit = customElements.get('aquarium-builder-kit');
  if (!Kit || Kit.prototype.mountTeaser) return;

  const STYLE = `
.abk-teaser{display:flex;align-items:center;gap:12px;margin:16px 0 4px;padding:12px 14px;border:1px solid #bae6fd;border-radius:14px;background:#f0f9ff;color:#22292d;font-size:14px;line-height:1.4;text-align:left;width:100%;box-sizing:border-box;cursor:pointer;font-family:inherit}
.abk-teaser:hover{border-color:#7dd3fc}
.abk-teaser:focus-visible{outline:2px solid #0369a1;outline-offset:2px}
.abk-teaser__icon{flex:0 0 auto;color:#0369a1;display:grid;place-items:center}
.abk-teaser__text{flex:1;min-width:0}
.abk-teaser__text strong{font-weight:700}
.abk-teaser__text b{color:#15803d;font-weight:700;white-space:nowrap}
.abk-teaser__go{flex:0 0 auto;display:inline-flex;align-items:center;gap:4px;color:#0369a1;font-weight:700;white-space:nowrap}
aquarium-builder-kit{scroll-margin-top:var(--abk-scroll-offset,96px)}`;

  function addStyle() {
    if (document.getElementById('abk-teaser-style')) return;
    const st = document.createElement('style');
    st.id = 'abk-teaser-style';
    st.textContent = STYLE;
    document.head.appendChild(st);
  }

  function findBuyForm(kit) {
    const forms = [...document.querySelectorAll('form[action*="/cart/add"]')].filter(f => !kit.contains(f) && !f.closest('.sticky-atc-bar, [data-sticky-atc], .quick-cart, .cross-sells') && f.querySelector('[name="add"], [type="submit"]'));
    return forms[0] || null;
  }

  // Leave room for the sticky header when scrolling to the kit.
  function headerOffset() {
    const header = document.querySelector('[data-section-type="header"], .header, header');
    const h = header ? header.getBoundingClientRect().height : 0;
    return Math.min(Math.max(h, 0), 160) + 16;
  }


  // Pull the buy buttons and the banner closer when only empty space sits between them.
  function hasContentBetween(top, bottom, skip) {
    const els = document.querySelectorAll('.product__block, .product__policies, .store-availability-container__wrapper, product-form > *, form[action*="/cart/add"] > *');
    for (const el of els) {
      if (skip.some(s => s === el || s.contains(el) || el.contains(s))) continue;
      const r = el.getBoundingClientRect();
      if (r.height > 1 && r.top >= top - 1 && r.bottom <= bottom + 1 && el.textContent.trim()) return true;
    }
    return false;
  }
  function closeGap(upper, lower, mover, target) {
    if (!upper || !lower || !mover) return;
    mover.style.marginTop = '';
    if (mover.contains(upper)) return;
    const gapNow = () => lower.getBoundingClientRect().top - upper.getBoundingClientRect().bottom;
    const a = upper.getBoundingClientRect(), b = lower.getBoundingClientRect();
    if (!a.height || !b.height) return;
    if (gapNow() <= target + 4 || gapNow() > 160 || hasContentBetween(a.bottom, b.top, [upper, lower, mover])) return;
    for (let i = 0; i < 3; i++) {
      const gap = gapNow();
      if (Math.abs(gap - target) < 2) break;
      const m = parseFloat(getComputedStyle(mover).marginTop) || 0;
      mover.style.marginTop = `${m - (gap - target)}px`;
    }
  }
  function tighten(kit) {
    const btn = kit.teaser;
    const form = btn && btn.previousElementSibling;
    if (!form) return;
    const submit = form.querySelector('.product-form__controls-group--submit') || form.querySelector('[name="add"]');
    const picker = [...document.querySelectorAll('.ch-variants')].find(el => !kit.contains(el) && el.getBoundingClientRect().height);
    const block = form.closest('.product__block') || form;
    if (picker && submit && picker.compareDocumentPosition(submit) & Node.DOCUMENT_POSITION_FOLLOWING) closeGap(picker, submit, block, 20);
    closeGap(submit, btn, btn, 16);
  }

  Kit.prototype.teaserText = function () {
    let from = Infinity, save = 0;
    for (const t of this.data.tiers) {
      const totals = this.tierTotals(t.id);
      if (totals.now > 0 && totals.now < from) from = totals.now;
      save = Math.max(save, totals.was - totals.now);
    }
    if (!isFinite(from)) return '';
    const labels = this.data.tiers.map(t => this.label(t.id));
    const names = labels.length > 1 ? `${labels.slice(0, -1).join(', ')} or ${labels[labels.length - 1]}` : labels[0];
    return `<strong>Pre-built kits ready:</strong> ${names} equipment from ${this.fmt(from)}${save > 0 ? ` · <b>save up to ${this.fmt(save)}</b>` : ''}`;
  };

  Kit.prototype.mountTeaser = function () {
    const text = this.teaserText();
    if (!text) return;
    if (!this.teaser) {
      const form = findBuyForm(this);
      if (!form) return;
      addStyle();
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'abk-teaser';
      btn.innerHTML = `<span class="abk-teaser__icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"/></svg></span><span class="abk-teaser__text"></span><span class="abk-teaser__go">See it<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M6 13l6 6 6-6"/></svg></span>`;
      btn.addEventListener('click', () => {
        this.style.setProperty('--abk-scroll-offset', `${headerOffset()}px`);
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block: 'start'});
      });
      (form.closest('product-form') || form).after(btn);
      this.teaser = btn;
      const run = () => { try { tighten(this); } catch (e) { /* spacing is cosmetic */ } };
      requestAnimationFrame(() => requestAnimationFrame(run));
      window.addEventListener('load', run);
      let t; window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(run, 150); });
    }
    const span = this.teaser.querySelector('.abk-teaser__text');
    if (span.innerHTML !== text) span.innerHTML = text;
  };

  const render = Kit.prototype.render;
  Kit.prototype.render = function (...args) {
    const out = render.apply(this, args);
    try { this.mountTeaser(); } catch (e) { /* banner is optional */ }
    return out;
  };

  // A kit that rendered before this script loaded still gets its banner.
  document.querySelectorAll('aquarium-builder-kit').forEach(el => { if (el.data && !el.hidden) { try { el.mountTeaser(); } catch (e) { /* optional */ } } });
})();